import tabSystem from "./tabs-custom";

const filterTariffe = () => {
	const BASE_URL = document.getElementById('base_url').value;
	const strutturaID = document.getElementById('tariffe-vue').dataset.strutturaid;
	let endpoint_tariffa = '';
	if(strutturaID){
		endpoint_tariffa = `${BASE_URL}/wp-json/api/v1/tariffe_struttura?id=`+strutturaID;
	}
	var app = new Vue({
		el: '#tariffe-vue',
		data() {
			return {
				tariffe : [],
				selectedSoggiorno : '',
				selectedCamera : '',
				selectedOrderPrice: 'prezzo crescente',
				selectedTipoStruttura : ''
			}
		},
		mounted(){
			
			fetch(endpoint_tariffa)
			.then(res => res.json())
			.then(data => {
				this.tariffe = data;
				this.sortBy('asc');
            }),
			this.toggleDrop();

			// setto selectedTipo struttura con valore del data della prima tab per il primo caricamento
			this.selectedTipoStruttura = document.querySelector('.tabs-custom-navi__item').dataset.tipostruttura;
		},
		updated(){
			tabSystem();
			refreshFsLightbox();
		},
		methods: {
			readmoreToggle(event){
				let element = event.target;
				if(!element.classList.contains('collapsed')){
					element.innerHTML = 'Leggi di meno'
				}else{
					element.innerHTML = 'Leggi di più'
				}
			},
			openOffCanvas(e) {
				let off = e.target.dataset.bs;
				let myOffcanvas = document.getElementById(off)
				let bsOffcanvas = new Offcanvas(myOffcanvas).show();
			},
			setTipoStruttura(tipo){
				this.selectedTipoStruttura = tipo;
			},
			toggleDrop(e){
				let selettoriFiltriSearchInput = document.querySelectorAll(".filters-item.--search .filter-search__input input");				
				let isVisible = e.target.closest(".filters-item").classList.contains('visible-list');

				selettoriFiltriSearchInput.forEach(el => {
					el.closest(".filters-item").classList.remove('visible-list');
				});	

				e.target.closest(".filters-item").classList.toggle('visible-list',!isVisible);			
				
				window.addEventListener('mouseup', function(e){   
					selettoriFiltriSearchInput.forEach(el => {
						if (!el.contains(e.target) && el.closest(".filters-item").classList.contains('visible-list')){
							el.closest(".filters-item").classList.remove('visible-list');
						}
					});
					
				});
			},
			selectCurrentFilterUI(selectedFilter, selectedValue){
				if(selectedFilter == 'soggiorno'){
					this.selectedSoggiorno = selectedValue;
				} else if (selectedFilter == 'camera'){
					this.selectedCamera = selectedValue;
				}
			},
			sortBy(key) {
				if(key == 'asc'){
					this.selectedOrderPrice = 'prezzo crescente';
					return this.tariffe.sort(function(a, b) {
						var priceA = a.tariffa;
						var priceB = b.tariffa;
						return (priceA < priceB) ? -1 : (priceA > priceB) ? 1 : 0;
					});
				} else if(key == 'desc'){
					this.selectedOrderPrice = 'prezzo decrescente';
					return this.tariffe.sort(function(a, b) {
						var priceA = a.tariffa;
						var priceB = b.tariffa;
						return (priceA > priceB) ? -1 : (priceA < priceB) ? 1 : 0;
					});
				}
			},
			resetFilters(){
				this.selectedSoggiorno = '';
				this.selectedCamera = '';
			}
		},
		computed: {
			tariffeSoggiorno(){
				let soggiorno = [];
				this.computedTariffe.forEach(tariffa => {
					if(!soggiorno.includes(tariffa.tipo_di_soggiorno)){
						if(tariffa.tipo_di_soggiorno != ''){
							soggiorno.push(tariffa.tipo_di_soggiorno);
						}
					}
				});
				return soggiorno;
			},
            tariffeCamera(){
				let camera = [];
				this.computedTariffe.forEach(tariffa => {
					if(!camera.includes(tariffa.tipo_di_camera)){
						camera.push(tariffa.tipo_di_camera);
					}
				});
				return camera;
			},
			tariffePrezzo(){
				let prezzo = [];
				this.computedTariffe.forEach(tariffa => {
					if(!prezzo.includes(tariffa.tariffa)){
						prezzo.push(tariffa.tariffa);
					}
				});
				return prezzo;
			},
			computedTariffe(){				
				
				return this.tariffe.filter( //controllo tutti gli item e mi ritorna solo gli elementi per cui il return è sempre true

					(item) => {	
					var soggiorno = this.selectedSoggiorno ? (item.tipo_di_soggiorno.toLowerCase().includes(this.selectedSoggiorno.toLowerCase())) : true, 
						tipoStruttura = this.selectedTipoStruttura ? (item.tipo_di_struttura.toLowerCase().includes(this.selectedTipoStruttura.toLowerCase())) : true,
						camera = this.selectedCamera ? (item.tipo_di_camera.toLowerCase().includes(this.selectedCamera.toLowerCase())) : true;
						return soggiorno && camera && tipoStruttura
					}
				) /* filter */

			}
			
		}
	})

}

export default filterTariffe;